import {use} from 'i18next';
import {initReactI18next} from 'react-i18next';

import {DEFAULT_LANGUAGE} from 'constants/language';
import {LanguageService} from 'services/Language';

import {resources} from './resources';

export default () => {
    use(initReactI18next)
        .init({
            resources,
            lng: LanguageService.getLanguage(),
            fallbackLng: DEFAULT_LANGUAGE,
            interpolation: {
                escapeValue: false
            }
        });
};
